<template>
  <div>
    <div class="">
      <div class="d-flex justify-content-between align-items-center">
        <div class="section-title">
          {{ $tc("distributor", 1) }} {{ $t("share") }} {{ $t("type") }}
        </div>

        <div class="d-flex justify-content-between align-items-center my-3">
          <div class="d-flex"></div>
          <div class="d-flex align-items-center">
            <!-- <FilterByStatusDropdown /> -->
            <div class="mx-2">
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  <!-- Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp; -->
                  <strong>{{ viewingRange }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
            <button
              class="btnj btn-gridView mr-3"
              v-if="GridViewFlag"
              :class="gridView ? 'active' : ''"
              v-on:click="viewType('gridView')"
            ></button>
            <button
              class="btnj btn-listView"
              v-if="GridViewFlag"
              :class="listView ? 'active' : ''"
              v-on:click="viewType('listView')"
            ></button>
          </div>
        </div>
      </div>
      <!-- <div>
        <b-button
          variant="default"
          to="add-distributor-share-type"
          class="btn-blue"
        >{{ $tc('add') }}</b-button>
      </div>-->
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView" style="margin-bottom: 25px">
      <thead>
        <tr>
          <th class="text-left" style="width: 100px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th class="text-left" style="padding-left: 10px">
            <img
              v-if="this.columnName != 'dst_label'"
              @click="onSortValue('dst_label', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('dst_label', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('dst_label', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("distributor", 1) }} {{ $t("share") }} {{ $t("type") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(
            distributorShareType, distributorShareTypeIndex
          ) in distributorShareTypeList"
          :key="distributorShareTypeIndex"
          class="light_grey_back"
        >
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  distributorShareType.dst_is_active === 'Y'
                    ? 'active'
                    : 'inactive'
                "
              />
              <span
                v-if="$can('update', 'Share Type')"
                class="edit-icon ml-4 blue-icon"
                @click="
                  goToRoute(
                    '/distributor/edit-distributor-share-type',
                    distributorShareType
                  )
                "
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
              <span
                class="view-icon ml-2 blue-icon"
                @click="
                  goToRoute(
                    '/distributor/view-distributor-share-type',
                    distributorShareType
                  )
                "
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </span>
            </div>
          </td>

          <td style="text-align: left">{{ distributorShareType.dst_label }}</td>
        </tr>
        <tr v-if="distributorShareTypeList.length == 0">
          <td colspan="2">
            <h5 class="text-center">No Records Found</h5>
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(
          distributorShareType, distributorShareTypeIndex
        ) in distributorShareTypeList"
        :key="distributorShareTypeIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ distributorShareType.dst_label }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/distributor/edit-distributor-share-type',
                      distributorShareType
                    )
                  "
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/distributor/view-distributor-share-type',
                      distributorShareType
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <!-- <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>-->
            <div class="col-4">
              <b-form-checkbox
                v-model="distributorShareType.dst_is_active"
                unchecked-value="N"
                value="Y"
                name="check-button"
                switch
              ></b-form-checkbox>
              <StatusDot
                :status="
                  distributorShareType.dst_is_active === 'Y'
                    ? 'active'
                    : distributorShareType.dst_is_active === 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="distributorShareTypeList.length == 0">
        <h5>No Records Found</h5>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import DistributorService from "@/services/DistributorService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      // Saif
      distributorShareTypeList: [],
      distributorShareTypeMethods: {
        GET: "/admin/",
        tableName: "distributor_share_type",
        urlKey: "",
      },
      //
      gridView: false,
      listView: true,

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getviewingnumber();
    this.getDistributorShareType();
  },
  mounted() {},
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getDistributorShareType();
      } else {
        this.currentPage = event;
        this.getDistributorShareType();
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getDistributorShareType();
    },
    // Saif
    getDistributorShareType: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      DistributorService.GetDistributorShareType(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.distributorShareTypeList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, { dst_id }) {
      this.$router.push({
        path: path,
        query: {
          id: dst_id,
        },
      });
    },
    changeStatus: function (item) {
      DistributorService.updateDistributorShareType(item)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    // getDistributorShareType: function() {
    //   this.distributorShareTypeList = [];
    //   let body = this.getRequestBody(
    //     "GET",
    //     undefined,
    //     this.distributorShareTypeMethods
    //   );
    //   console.log("body :", body);
    //   MasterService.GlobalRequest(body)
    //     .then(response => {
    //       const { data } = response;
    //       if (data && data.status && data.Records.length > 0) {
    //         this.distributorShareTypeList = data.Records;
    //       } else {
    //         // Show Errors
    //         console.log("show error :", data.message);
    //       }
    //     })
    //     .catch(error => {
    //       // Show Catch Error
    //       console.log("show error :", error);
    //     });
    // },
    // Saif

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorShareTypeComponents/distributorShareType.vue